function BackPageComponent(props) {
  return <div className="backPage"></div>;
}

export default BackPageComponent;
